<template>
  <v-row no-gutters>
    <v-col cols="2" v-for="m in mesi" :key="m.num" class="pa-1">
      <v-btn block outlined :color="value.includes(m.num) ? 'green' : 'grey'" @click="toggle(m.num)">
        {{ m.label }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      mesi: [
        { num: 1, label: 'Gen' }, { num: 2, label: 'Feb' }, { num: 3, label: 'Mar' },
        { num: 4, label: 'Apr' }, { num: 5, label: 'Mag' }, { num: 6, label: 'Giu' },
        { num: 7, label: 'Lug' }, { num: 8, label: 'Ago' }, { num: 9, label: 'Set' },
        { num: 10, label: 'Ott' }, { num: 11, label: 'Nov' }, { num: 12, label: 'Dic' },
      ],
    };
  },
  methods: {
    toggle(num) {
      const nuovi = this.value.includes(num)
        ? this.value.filter(m => m !== num)
        : [...this.value, num];
      this.$emit('input', nuovi);
    },
  },
};
</script>
